import styles from 'css/src/components/share-video/TranscriptModal.module.scss';

import React from 'react';

import Modal from 'js/src/components/common/ui/modal';
import Tooltip, { Placement } from 'js/src/components/common/ui/Tooltip';
import { parseScript } from 'js/src/libs/transcript';
import { useLuminarySelector } from 'js/src/luminary/luminary-hooks';

const Transcript = React.memo(function Transcript() {
    const transcript = useLuminarySelector((luminary) => parseScript(luminary, '\n\n'), []);

    return <p className="py-l5-16">{transcript}</p>;
});

type Props = {
    showing: boolean;
    onHidden: VoidFunction;
};

const TranscriptModal = React.memo(function TranscriptModal({ showing, onHidden }: Props) {
    return (
        <Modal
            showing={showing}
            className={styles['transcript-modal']}
            onHidden={onHidden}
            title={
                <span>
                    Transcript&nbsp;
                    <Tooltip
                        placement={Placement.BOTTOM}
                        trigger="hover"
                        container={`.${styles['transcript-modal']} .modal-content`}
                        title="This is a transcript of all the text that appears in the video."
                    >
                        <i className="material-symbols-outlined">help</i>
                    </Tooltip>
                </span>
            }
        >
            <div className="container-fluid">
                <Transcript />
            </div>
        </Modal>
    );
});

export default TranscriptModal;
